import React, { useEffect, useState } from 'react'

import { MuiThemeProvider } from '@material-ui/core/styles'
import { GetMuiThemeEco, GetMuiThemeOem } from 'Components/UI/Atoms/Table/DynamicStyle'
import { Options } from 'Components/UI/Atoms/Table/Options'
import MUIDataTable from 'mui-datatables'
import { useHistory, useLocation } from 'react-router-dom'
import { getUbicacion } from 'service/helpers/localstorage'

const MuiDatables = (props) => {
  const {
    title,
    data,
    columns,
    apiCall,
    count,
    textPlaceholder,
    render,
    setRender,
    columnTheme,
    searchEnabled,
    expandableRows,
    renderExpandableRow,
    selectableRows,
    customToolbarSelect,
    customToolbar,
    padding,
    filterEnabled,
    isRowSelectable,
    setRowProps,
    rows = 25,
    advancedSearch,
    onRowClick,
    searchFirst,
    defaultFilters = '',
  } = props

  const [offset, setOffset] = useState(0)
  const [isSearching, setIsSearching] = useState(true)
  const [sort, setSort] = useState({
    orderBy: 'id',
    order: 'desc',
  })
  const [filters, setFilters] = useState(defaultFilters || '')
  const [search, setSearch] = useState()

  const history = useHistory()
  const { pathname, search: locationSearch } = useLocation()
  const location = getUbicacion() || ''

  const updateQueryParam = (name, value) => {
    const params = new URLSearchParams(locationSearch || '')
    if (value === undefined || value === null || value === '') {
      params.delete(name)
    } else {
      params.set(name, String(value))
    }
    const next = params.toString()
    history.replace(next ? `${pathname}?${next}` : pathname)
  }

  const theme = () => {
    if ((pathname && pathname.includes('oem')) || location.includes('OEM'))
      return GetMuiThemeOem(columnTheme)
    return GetMuiThemeEco(columnTheme)
  }

  const functions = {
    render,
    filters,
    setRender,
    setSort,
    setSearch,
    setOffset,
    setFilters,
    updateQueryParam,
    isSearching,
    count,
    textPlaceholder,
    searchEnabled,
    expandableRows,
    renderExpandableRow,
    selectableRows,
    customToolbarSelect,
    customToolbar,
    padding,
    filterEnabled,
    isRowSelectable,
    setRowProps,
    rows,
    onRowClick,
    searchFirst,
  }

  useEffect(() => {
    setIsSearching(true)
    let options = {
      offset: `?offset=${offset}`,
      limit: `&limit=${rows}`,
      orderby: `&orderby=${sort.orderBy}`,
      order: `&order=${sort.order}`,
      search: '',
      filters: filters || '',
    }
    if (search !== undefined) {
      options.search = `&search=${search}`
    }
    if (advancedSearch && advancedSearch !== '') {
      options.search = advancedSearch
    }
    let finalQuery = Object.values(options).join('')
    apiCall(finalQuery, function () {
      setIsSearching(false)
    })
    // eslint-disable-next-line
  }, [render])

  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme()}>
        <MUIDataTable title={title} data={data} columns={columns} options={Options(functions)} />
      </MuiThemeProvider>
    </React.Fragment>
  )
}
export default MuiDatables
